import {Vector3, Euler} from 'three'
import gradientParams from './gitlines-gradient-params'

interface Timeline {
  duration: number
  delay: number
}

export interface Line {
  name: string
  position: THREE.Vector3
  rotation: THREE.Euler
  scale: number
  lineWidth: number
  timeline: Timeline | null
  gradient: typeof gradientParams
  alpha?: number
}

interface Group {
  lines: Line[]
  position: THREE.Vector3
  rotation: THREE.Euler
}

export default {
  mouseParallax: [0.1, 0.1] as [number, number],
  group: {
    lines: [
      {
        name: 'gitlines1',
        position: new Vector3(0.0, 0.0, 0.0),
        rotation: new Euler(0, 0, 0),
        scale: 3.8 * 0.8,
        lineWidth: 0.7,
        gradient: gradientParams,
      },
      {
        name: 'gitlines2',
        position: new Vector3(0.0, 0.0, 0.0),
        rotation: new Euler(0, 0, 0),
        scale: 3.8 * 0.8,
        lineWidth: 0.4,
        alpha: 0.1,
        gradient: gradientParams,
      },
    ],
    position: new Vector3(0, 0, 0),
    rotation: new Euler(0, 0, 0),
  } as Group,
}
